import {PATH_DASHBOARD} from '@feg/ui'
import {useTranslation} from 'react-i18next'
import AddEditLocationButton from '../../../components/admin/location/AddEditLocationButton'
import LocationList from '../../../components/admin/location/LocationList'
import {PageRoot} from "@feg/ui/src/common/layout/PageRoot";


export default function LocationPage() {
    const {t} = useTranslation()
    return (
        <PageRoot title={t('location.list.main')}
                  breadcrumbs={{
                      heading: t('location.list.main'),
                      links: [
                          {name: t('dashboard.main'), href: PATH_DASHBOARD.general.app},
                          {name: t('location.list.main'), href: PATH_DASHBOARD.location.list}
                      ],
                      action: (
                          <AddEditLocationButton/>
                      )
                  }}>
            <LocationList/>
        </PageRoot>
    )
}

